export default __webpack_public_path__ + "static/media/thumbnail.cbc796dc.png";